import mitt from "mitt"

export const EventBus = mitt()
export default EventBus
